import { render } from "./RoomForm.vue?vue&type=template&id=c659ba36"
import script from "./RoomForm.vue?vue&type=script&lang=js"
export * from "./RoomForm.vue?vue&type=script&lang=js"

import "./RoomForm.vue?vue&type=style&index=0&id=c659ba36&lang=scss"

import exportComponent from "/srv/crewmaldives/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__